const pendingSkipDestinations = new Map<string, number>()

export const getHistoryPageSyncDestinationKey = (
  name: string,
  params: Record<string, unknown>,
) =>
  JSON.stringify({
    name,
    filters: params.filters ?? null,
    d: params.d ?? null,
    q: params.q ?? null,
    offset: params.offset ?? null,
    suggestion: params.suggestion ?? null,
  })

export const skipNextHistoryPageSync = (destinationKey: string) => {
  pendingSkipDestinations.set(
    destinationKey,
    (pendingSkipDestinations.get(destinationKey) ?? 0) + 1,
  )
}

export const consumeSkipNextHistoryPageSync = (destinationKey: string) => {
  const remaining = pendingSkipDestinations.get(destinationKey)
  if (!remaining) {
    return false
  }

  if (remaining === 1) {
    pendingSkipDestinations.delete(destinationKey)
  } else {
    pendingSkipDestinations.set(destinationKey, remaining - 1)
  }

  return true
}

export const cancelSkipNextHistoryPageSync = (destinationKey: string) => {
  pendingSkipDestinations.delete(destinationKey)
}

export const resetSkipNextHistoryPageSync = () => {
  pendingSkipDestinations.clear()
}
